export class InspeccionPeriodoCamViewModel {
    constructor() {}

    public Id: number;
    public IdPeriodo: number;
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public IdTipoInspeccion: number;
    public TipoInspeccion: string;
    public Nombre: string;
    public Definicion: string;
    public TieneFechaFin: boolean;
    public Obligatoria: boolean;
    public PeriodoFechaInicio?: Date;
    public PeriodoFechaFin?: Date;
}

export class ListaInspeccionPeriodoViewModel {
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public PeriodoFechaInicio?: Date;
    public PeriodoFechaFin?: Date;
    public InspeccionPeriodoCollection: InspeccionPeriodoCamViewModel[];
}
